import { useEffect } from 'react';
import gtag from '../../analytics/gtag';
import { WrapTrackingContext } from '../../generic/TrackingContext';
import StructuredData from '../../utils/StructuredData';
import type { ProductCardDetails } from '../ProductCard';
import type { ProductCharacteristicsProps } from './ProductCharacteristics';
import ProductCharacteristics from './ProductCharacteristics';
import ProductDetails from './ProductDetails';
import * as style from './ProductDetailsPage.module.css';
import ProductImageAndMainInfo from './ProductImageAndMainInfo';
import type { ProductArea } from './ProductOriginLinks';
import type { ProductStickersProps } from './ProductStickers';
import SimilarProducts from './SimilarProducts';
import { getProductStructuredData } from './structuredProductData';

/* A lot of values are optional because of products such as gift-bags and cards*/
export interface DetailedProduct extends ProductCardDetails, ProductCharacteristicsProps, ProductArea, ProductStickersProps {
    taste?: string;
    smell?: string;
    main_producer?: { name: string };
    color?: string;
    ageLimit: number;
    year: string;
    similarProducts: boolean;
    statusNotification?: boolean;
}

export interface Props {
    product: DetailedProduct;
}

export default function ProductDetailsPage({ product }: Props) {
    useEffect(() => {
        gtag('event', 'view_item', {
            items: [{ item_id: product.code }],
        });
    }, [product.code]);

    return (
        <WrapTrackingContext set={{ item_id: product.code }}>
            <div className={style.product}>
                <section className="section__inner-container">
                    <ProductImageAndMainInfo product={product} />
                </section>
                <div className={style.sectionGrey}>
                    <section className="section__inner-container">
                        <ProductCharacteristics content={product.content} sustainable={product.sustainable} stickers={product.stickers} />
                        {product.content && <hr className={style.onlyDesktop} />}
                        <ProductDetails product={product} />
                        <SimilarProducts productId={product.code} show={product.similarProducts} />
                        <hr />
                    </section>
                </div>
                <StructuredData data={product} mapper={getProductStructuredData} />
            </div>
        </WrapTrackingContext>
    );
}
